import { render, staticRenderFns } from "./redirect.vue?vue&type=template&id=ac87c062&scoped=true&"
import script from "./redirect.vue?vue&type=script&lang=js&"
export * from "./redirect.vue?vue&type=script&lang=js&"
import style0 from "./redirect.vue?vue&type=style&index=0&id=ac87c062&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac87c062",
  null
  
)

export default component.exports